module.exports = __webpack_public_path__ + "static/media/hobbies.7c349e4a.webp";